var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Quodoc_-_secondary_-_black_-_RGB",
    "data-name": "Quodoc - secondary - black - RGB",
    xmlns: "http://www.w3.org/2000/svg",
    width: 340.783,
    height: 79.454,
    viewBox: "0 0 340.783 79.454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404",
    transform: "translate(86.226 19.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M211.521,82.723a17.949,17.949,0,0,1-7.742-6.743,19.048,19.048,0,0,1-2.749-10.324,20.2,20.2,0,0,1,2.749-10.547,18.913,18.913,0,0,1,7.493-7.133A22.254,22.254,0,0,1,221.9,45.45a22.019,22.019,0,0,1,10.573,2.526,18.732,18.732,0,0,1,7.468,7.133,20.344,20.344,0,0,1,2.719,10.547,14.882,14.882,0,0,1-1.583,6.58,15.422,15.422,0,0,1-3.912,5.19h6.494v7.661H223.124a26.879,26.879,0,0,1-11.6-2.359Zm15.767-7.356a9.924,9.924,0,0,0,3.886-3.83,12.548,12.548,0,0,0,.026-11.628,10,10,0,0,0-3.856-3.83,11.007,11.007,0,0,0-5.439-1.36,11.208,11.208,0,0,0-5.494,1.36,9.966,9.966,0,0,0-3.856,3.83,11.469,11.469,0,0,0-1.415,5.8,11.628,11.628,0,0,0,1.415,5.829,9.677,9.677,0,0,0,3.886,3.83A11.34,11.34,0,0,0,221.91,76.7a10.9,10.9,0,0,0,5.383-1.334Z",
    transform: "translate(-201.03 -45.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M315.219,82.33q-4.439-4.69-4.439-12.4V47.39h9.827V70.037a7.8,7.8,0,0,0,2.08,5.885,7.947,7.947,0,0,0,5.743,2,7.074,7.074,0,0,0,7.772-7.884V47.39h9.827V69.926q0,7.772-4.414,12.434T328.43,87.022Q319.661,87.022,315.219,82.33Z",
    transform: "translate(-263.706 -46.558)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M415.493,83.362A19.147,19.147,0,0,1,408,76.23a20.046,20.046,0,0,1-2.75-10.517A20.2,20.2,0,0,1,408,55.165,19.1,19.1,0,0,1,415.493,48a22.071,22.071,0,0,1,10.629-2.552A21.84,21.84,0,0,1,436.694,48a18.923,18.923,0,0,1,7.468,7.163,20.343,20.343,0,0,1,2.719,10.547,20.222,20.222,0,0,1-2.719,10.517,18.967,18.967,0,0,1-7.468,7.133,23.292,23.292,0,0,1-21.2,0Zm16.011-8a9.924,9.924,0,0,0,3.886-3.83,12.549,12.549,0,0,0,.026-11.628,10,10,0,0,0-3.856-3.83,11.007,11.007,0,0,0-5.439-1.36,11.209,11.209,0,0,0-5.495,1.36,9.967,9.967,0,0,0-3.856,3.83,11.469,11.469,0,0,0-1.416,5.8,11.629,11.629,0,0,0,1.416,5.829,9.677,9.677,0,0,0,3.886,3.83,11.341,11.341,0,0,0,5.469,1.334,10.9,10.9,0,0,0,5.383-1.334Z",
    transform: "translate(-317.655 -45.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M515.25,47.39h13.931a25.108,25.108,0,0,1,11.157,2.333,16.959,16.959,0,0,1,7.356,6.691A19.617,19.617,0,0,1,550.276,66.6q0,9.657-5.661,14.626t-15.708,4.967H515.25Zm14.489,30.531q5.05,0,7.742-3.054a12.062,12.062,0,0,0,2.694-8.27,11.489,11.489,0,0,0-2.694-7.854,9.332,9.332,0,0,0-7.412-3.08h-5V77.921h4.663Z",
    transform: "translate(-380.474 -46.558)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M617.5,83.362a19.151,19.151,0,0,1-7.493-7.133,20.048,20.048,0,0,1-2.749-10.517,20.2,20.2,0,0,1,2.749-10.547A19.106,19.106,0,0,1,617.5,48a22.073,22.073,0,0,1,10.629-2.552A21.844,21.844,0,0,1,638.7,48a18.924,18.924,0,0,1,7.467,7.163,20.342,20.342,0,0,1,2.719,10.547,20.218,20.218,0,0,1-2.719,10.517,18.968,18.968,0,0,1-7.467,7.133,23.293,23.293,0,0,1-21.2,0Zm16.016-8a9.92,9.92,0,0,0,3.886-3.83,12.545,12.545,0,0,0,.026-11.628,9.995,9.995,0,0,0-3.855-3.83,11.007,11.007,0,0,0-5.439-1.36,11.206,11.206,0,0,0-5.494,1.36,9.963,9.963,0,0,0-3.856,3.83,11.464,11.464,0,0,0-1.416,5.8,11.624,11.624,0,0,0,1.416,5.829,9.673,9.673,0,0,0,3.886,3.83A11.338,11.338,0,0,0,628.14,76.7a10.9,10.9,0,0,0,5.383-1.334Z",
    transform: "translate(-433.019 -45.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M722.75,83.474a17.443,17.443,0,0,1-7.412-7.021,21.318,21.318,0,0,1-2.608-10.74,21.363,21.363,0,0,1,2.608-10.74,17.588,17.588,0,0,1,7.412-7.051,23.992,23.992,0,0,1,11.131-2.471,30.355,30.355,0,0,1,7.437.832,20.528,20.528,0,0,1,6.052,2.608v9.325a15.824,15.824,0,0,0-5.524-2.831,25.619,25.619,0,0,0-7.077-.888q-5.719,0-8.827,2.968t-3.11,8.244a10.9,10.9,0,0,0,3.135,8.27q3.134,3,8.8,3a24.972,24.972,0,0,0,7.159-.944,18.426,18.426,0,0,0,5.885-3V82.3q-5.276,3.609-13.931,3.607a24.254,24.254,0,0,1-11.131-2.441Z",
    transform: "translate(-493.25 -45.45)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M56.594,51.65Z",
    transform: "translate(-32.317 -29.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M56.566,51.65a.31.31,0,0,0-.026.021c.009,0,.013-.013.021-.017h0Z",
    transform: "translate(-32.289 -29.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M56.59,51.65h0l0,0Z",
    transform: "translate(-32.317 -29.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M46.32,76.776a14.234,14.234,0,0,1-1.729-2.634c-.013-.021-.021-.043-.034-.064-.142-.283-.279-.57-.4-.866-.021-.051-.047-.1-.069-.15l.013.009a14.193,14.193,0,0,1,.926-12.55c-5.855,9.393-3.963,26.975,14.468,51.973,5.156-3.629,17.942-13.438,25.371-26.147C64.184,88.795,51.72,84.261,46.315,76.78Z",
    transform: "translate(-24.029 -34.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M76.816,28.978c.116.433.21.866.287,1.3.009.047.017.1.026.146v.021a14.192,14.192,0,0,1-.33,6.768c-.013.043-.021.086-.034.129h0a14.144,14.144,0,0,1-2.792,5.048c5.863-5.585,10.7-16,13.485-31.86A33.175,33.175,0,0,0,52.53,1.767C67.963,10.213,75.413,20.361,76.816,28.978Z",
    transform: "translate(-29.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M73.7,60.986a14.132,14.132,0,0,1-9.419,3.74.283.283,0,0,0-.06,0H64.1A14.142,14.142,0,0,1,54.08,60.592c6.207,6.361,19.121,9.115,39.1,5.906a35.28,35.28,0,0,0,4.135-15.9A33.064,33.064,0,0,0,90.483,30.43C86.755,46.33,80.532,56.255,73.7,60.991Z",
    transform: "translate(-30.884 -17.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M47.894,92.194c-.013-.021-.021-.043-.034-.064C47.873,92.151,47.881,92.173,47.894,92.194Z",
    transform: "translate(-27.332 -52.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M46.77,89.75c.021.051.047.1.069.15-.021-.047-.039-.094-.056-.142Z",
    transform: "translate(-26.709 -51.254)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M77.72,110.394a.409.409,0,0,0,.06,0h-.056Z",
    transform: "translate(-44.384 -63.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M34.58,23.1a14.2,14.2,0,0,1,12.289,10.26c-.017-.112-.03-.219-.047-.33-2.136-8.15-10.654-17-27.485-25.937A33.21,33.21,0,0,0,0,37.265c0,.51.017,1.017.043,1.518C13.8,26.314,25.868,21.871,34.575,23.093Z",
    transform: "translate(0 -4.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M109.06,86.9c.013-.043.021-.086.034-.129-.013.043-.021.086-.034.124h0Z",
    transform: "translate(-62.282 -49.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M109.89,70.93v0Z",
    transform: "translate(-62.756 -40.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M109.15,67.56c.017.112.034.219.047.33.09.317.172.639.24.969C109.36,68.431,109.262,68,109.15,67.56Z",
    transform: "translate(-62.333 -38.582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M33.7,105.084l.051-.03c-19.456-28.832-19.76-48.859-9.089-57.193l.069-.056c.009-.009.017-.013.026-.021h0a14.137,14.137,0,0,1,6.189-2.9C22.552,45.751,12,51.528.84,63.474c3.616,23.128,32.851,41.61,32.851,41.61Z",
    transform: "translate(-0.48 -25.63)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.81e9c198df03e65ae853b0dadc735f0d.svg";
export { ForwardRef as ReactComponent };